/**
 * Copied from router.config.js
 * Will probably not be modified in router.config.js, but to be careful
 */
export function addTaskStates($stateProvider, prefix) {
  $stateProvider.state(prefix + '.process', {
    url: '/task/{processedTaskId:int}?acquire&hide-nav',
    resolve: {
      acquire: [
        '$stateParams',
        'AngularTaskActionsService',
        'loggedUser',
        '$state',
        '$q',
        function ($stateParams, AngularTaskActionsService, loggedUser, $state, $q) {
          if (loggedUser.is_in_push_mode) {
            $state.go('auth.alcmeon.pushbox.process', {
              companyId: $stateParams.companyId,
              processedTaskId: $stateParams.processedTaskId,
              acquire: null,
            });
            return $q.reject();
          }

          if ($stateParams.acquire) {
            // value of 'acquire' resolve is not used in controller, so no need to care about return value
            AngularTaskActionsService.assign($stateParams.processedTaskId, $stateParams.acquire).subscribe();
          }
        },
      ],
    },
    views: {
      task: {
        template: require('src/ajs-app/components/tasks/task-process-wrapper/task-process-wrapper.html'),
        controller: 'TaskProcessWrapperController',
      },
      // hide tabs nav in processing page
      'tabs-nav@auth': {},
      // don't want ChannelsNavigationComponent to be loaded (hidden) in PP, because its constructor triggers initChannelsCountersBS,
      // and it's a mess without TabsNavigationComponent being loaded at the same time (because of zip in counters.service.ts)
      'sub-nav@auth': {},
    },
  });
}
